module.exports = __webpack_public_path__ + "static/media/IBMDTP.08b31adf.pdf";